export default {
  metrics: {
    go_lives: 'Julkaisut yhteensä',
    avg_quality_score: 'Keskimääräinen laatupisteytys',
    managers: {
      title: 'Käyttöönottopäälliköt',
      fields: {
        name: 'Päällikön nimi',
        go_lives: 'Julkaisut',
        avg_quality_score: 'Keskim. laatupisteytys',
      },
    },
  },
  details: {
    name: 'Ravintola',
    owner: 'Omistajan nimi',
    owner_phone: 'Omistajan puhelin',
    owner_email: 'Omistajan sähköposti',
    live_from: 'Julkaisupäivä',
    onboarding_manager: 'Käyttöönottopäällikkö',
    sales_manager: 'Myyntipäällikkö',
    onboarding_quality_score: 'Laatupisteytys',
    export_csv: 'Vie CSV',
  },
};
